export default function ServiceAreas() {
  const towns = [
    'Glen Mills', 'Media', 'Newtown Square', 'Chadds Ford',
    'Concord', 'Garnet Valley', 'Thornton', 'Aston',
    'Brookhaven', 'Wallingford', 'Swarthmore', 'Springfield'
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="grid lg:grid-cols-5 gap-12 items-center">
          {/* Map - Left */}
          <div className="lg:col-span-2">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/7f6c6a38f75f2f1efc9f1ef1c2ccb3f9.jpg"
                alt="Service area map"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#E67E22]/20 to-transparent"></div>
            </div>
          </div>

          {/* Content - Right */}
          <div className="lg:col-span-3 bg-[#2C2C2C] rounded-3xl p-12 lg:p-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-white leading-tight mb-8">
              Proudly Serving Delaware County
            </h2>
            <p className="text-lg text-gray-300 mb-10 leading-relaxed">
              As a locally owned and operated company, we're proud to serve homeowners throughout Delaware County and surrounding communities. Our deep roots in the area mean we understand the unique landscape challenges and opportunities of our region.
            </p>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-10">
              {towns.map((town, index) => (
                <div key={index} className="flex items-center gap-2">
                  <i className="ri-map-pin-fill text-[#E67E22]"></i>
                  <span className="text-white font-medium whitespace-nowrap">{town}</span>
                </div>
              ))}
            </div>
            <a href="/service-areas" className="inline-flex items-center gap-2 text-[#E67E22] font-semibold hover:gap-3 transition-all cursor-pointer whitespace-nowrap">
              See Full Service Area <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}